import React, { useEffect, useRef, useState } from 'react';
import mapboxgl from 'mapbox-gl';
import 'mapbox-gl/dist/mapbox-gl.css';
import { useParams } from 'react-router-dom';
import { getCrashDataById } from '../../api/api'; // Assuming `getCrashDataById` is an API call function
import { Box, Typography, CircularProgress, Grid, Paper, Table, TableBody, TableCell, TableRow } from '@mui/material';
import { MAP_BOX_API_KEY } from '../../services/AppConstant'; // Import Mapbox token from config file
mapboxgl.accessToken = MAP_BOX_API_KEY; // Set Mapbox API key

const CrashDetail = () => {
  const mapContainerRef = useRef(null);
  const { id } = useParams();
  const [crashDetail, setCrashDetail] = useState(null);

  useEffect(() => {
    // Fetch crash details by ID
    const fetchCrashData = async () => {
      try {
        const response = await getCrashDataById(id); // Assuming response contains `data` with crash details
        setCrashDetail(response.data);
      } catch (error) {
        console.error('Error fetching crash details:', error);
      }
    };

    fetchCrashData();
  }, [id]);

  useEffect(() => {
    if (crashDetail && crashDetail.location && crashDetail.location.coordinates) {
      const map = new mapboxgl.Map({
        container: mapContainerRef.current,
        style: 'mapbox://styles/mapbox/streets-v11',
        center: crashDetail.location.coordinates,
        zoom: 14,
      });

      new mapboxgl.Marker()
        .setLngLat(crashDetail.location.coordinates)
        .addTo(map);

      return () => map.remove();
    }
  }, [crashDetail]);

  if (!crashDetail) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <CircularProgress />
      </Box>
    );
  }

  const renderDetailRow = (key, value) => {
    const isDeathRow =
      key.toLowerCase().includes('death') && Number(value) > 0; // Highlight rows with deaths

    return (
      <TableRow key={key} sx={{ backgroundColor: isDeathRow ? 'rgba(255, 0, 0, 0.1)' : 'inherit' }}>
        <TableCell><strong>{key}</strong></TableCell>
        <TableCell>{value !== null && typeof value === 'object' ? JSON.stringify(value) : value.toString()}</TableCell>
      </TableRow>
    );
  };

  return (
    <Box sx={{ padding: 4 }}>
      <Typography variant="h4" gutterBottom>
        Crash Details
      </Typography>
      <Grid container spacing={4}>
         {/* Details Section */}
         <Grid item xs={12} md={6}>
          <Paper sx={{ padding: 3 }}>
            <Table>
              <TableBody>
                {Object.entries(crashDetail).map(([key, value]) => renderDetailRow(key, value))}
              </TableBody>
            </Table>
          </Paper>
        </Grid>
        {/* Map Section */}
        <Grid item xs={12} md={6}>
          <Box
            ref={mapContainerRef}
            sx={{
              width: '100%',
              height: '400px',
              borderRadius: 2,
              border: '1px solid #ccc',
            }}
          ></Box>
        </Grid>
       
      </Grid>
    </Box>
  );
};

export default CrashDetail;
